import { useApolloClient, useQuery } from "@graphcommerce/graphql";
import { CustomerTokenDocument } from "@graphcommerce/magento-customer";
import { useLoading } from "../../context/loadingContext";
import { useRouter } from "next/router";
import { CustomerCartDocument } from "@graphcommerce/magento-cart/hooks/CustomerCart.gql";
import { useMergeCustomerCart } from "@graphcommerce/magento-cart";
import { useMergeGuestWishlistWithCustomer } from "@graphcommerce/magento-wishlist";
import { useContext } from "react";
import { ModalContext } from "../../context/context";
import { customerDocument } from "../../graphql/login/currentCustomerData.gql";
import { useMergeCompareList } from "./useMergeCompareList";

const useLogin = () => {
  useMergeCustomerCart();
  const mergeCompareList = useMergeCompareList();
  const client = useApolloClient();
  const { refetch } = useQuery(customerDocument, { skip: true });
  const router = useRouter();
  const { setLoading } = useLoading();
  const useModal = useContext(ModalContext);
  const handleLogin = (token: string, onComplete: null | (() => void) = null, redirect: boolean = true, stayAtPage: boolean = false) => {
    client.writeQuery({
      query: CustomerTokenDocument,
      data: {
        customerToken:
        {
          __typename: 'CustomerToken',
          token,
          createdAt: (new Date()).toUTCString(),
          valid: true
        }
      },
      broadcast: true,
    });

    refetch().then(async ({ data: { customer } }) => {
      client.writeQuery({
        query: customerDocument,
        data: {
          customer
        },
        broadcast: true,
      });
    }).finally(async () => {
      await mergeCompareList();
      if (stayAtPage) {
        router.push(router.asPath)
      } else {
        redirect && await router.push('/');
      }
      redirect && useModal.close ? useModal.close() : null;
      onComplete && onComplete();
      setLoading(false);
    });
  }

  return { handleLogin }
}

export default useLogin;